

type sendFeedBack = {
    infographicId: string;
    infographicName: string;
    rating: number;
    comment: string;
    id_usuario?: number;
    nombre_usuario?: string;
    email?: string;
    issues?: string;
    modulo?: string;
    bv?: string;
}

/**
 * Permite enviar una calificación
 */
export const sendFeedBack = async({rating, comment, infographicId, infographicName, id_usuario, nombre_usuario, email, issues, modulo, bv}: sendFeedBack): Promise<boolean> => {

  try {
    const data = new FormData()
    data.append("fvu_practica", infographicName );
    data.append("fvu_calificacion", String(rating));
    data.append("fvu_opinion", comment );
    data.append("fvu_id_recurso", infographicId );

    if(id_usuario){
      data.append("fvu_id_usuario", id_usuario.toString() );
    }

    if(nombre_usuario){
      data.append("fvu_nombre_usuario", nombre_usuario );
    }

    if(email){
      data.append("fvu_email", email );
    }

    if(issues){
      data.append("fvu_problema_encontrado", issues );
    }

    if(modulo){
      data.append("fvu_modulo", modulo );
    }

    if(bv){
      data.append("fvu_id_bv", bv );
    }

    const res = await fetch(`https://apivirtualplant.com/apiVpro/public/api/saveValoracionUnity`, {
        method: 'POST',
        body: data,
        mode: 'cors'                  
    });

    const dataResponse = await res.json();

    if(dataResponse.fvu_practica){
        return true;
    }

    return false;
  } catch (error) {
    console.log("[ERROR][sendFeedBack]", error);
    return false;
  }
}